import { useEffect, useState } from 'react';
import { fetchAttachmentPolicy } from '@/app/services/issue/issueService';

/**
 * 서버가 받는 첨부 형식 — 답이 오기 전·오지 않으면 `null`(«모름»: 고를 때 판정하지 않고 서버의 거절에 맡긴다).
 * 빈 목록으로 두면 모든 첨부를 막는다.
 */
export function useAttachmentPolicy(): readonly string[] | null {
  const [types, setTypes] = useState<readonly string[] | null>(null);
  useEffect(() => {
    let alive = true;
    fetchAttachmentPolicy().then(
      (t) => { if (alive) setTypes(t); },
      () => { /* 모름 — 판정은 서버의 거절이 한다 */ },
    );
    return () => { alive = false; };
  }, []);
  return types;
}
